import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Loading from "./components/Loading"
import { BrowserRouter } from 'react-router-dom';

import React , { Suspense } from 'react';


const AppLoad  = React.lazy(()=>import("./App"))

ReactDOM.render(
    <Suspense fallback={<Loading/>}>
      <BrowserRouter>
          <AppLoad/>
      </BrowserRouter>
    </Suspense>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
